import { Container, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import { DocsLink, type DocsSection } from "@components";

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(4),
  position: "relative",
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

const ContentContainer = styled("div")(({ theme }) => ({
  minHeight: 0,
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(2),
  "& > *": { borderRadius: 0, border: "none" },
  height: "100%",
}));

type Props = {
  title: string;
  aboveContent?: React.ReactNode;
  // Rendered above the title (e.g. banners).
  topContent?: React.ReactNode;
  children: React.ReactNode;
  docsSection?: DocsSection;
};

const ViewWrapper = React.memo(function ViewWrapper({
  title,
  aboveContent,
  topContent,
  children,
  docsSection,
}: Props) {
  return (
    <StyledContainer maxWidth={false} disableGutters>
      {topContent}
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
      >
        <Grid
          item
          container
          direction="column"
          md={12}
          lg={aboveContent ? 3 : 12}
        >
          <Typography variant="h1">{title}</Typography>
          {docsSection && <DocsLink docsSection={docsSection} />}
        </Grid>
        <Grid
          item
          container
          direction="row"
          md={12}
          lg={9}
          justifyContent={{ lg: "flex-end", md: "flex-start" }}
          alignSelf="flex-start"
        >
          {/* TODO - ideally this would not be a component, but this pattern would be to iterate over components, or have a much more modular pattern that made aboveContent just feel like whatever components you want to pass in */}
          {aboveContent}
        </Grid>
      </Grid>
      <ContentContainer>{children}</ContentContainer>
    </StyledContainer>
  );
});

export { ViewWrapper };
